import React from 'react';

import Spacer from 'common/components/Spacer';

import { SPACING } from 'common/components/TouchpointEditor/components/TouchpointSidebar';
import {
    NodeContainer,
    NodeButton,
} from 'common/components/TouchpointEditor/components/TouchpointSidebar/ElementsListMenu';
import { Tooltip } from 'common/components/Tooltip/Tooltip';

import ShowHideButton from 'common/components/TouchpointEditor/components/TouchpointSidebar/ShowHideButton';
import ConditionalWrap from 'common/hoc/ConditionalWrap';

const buttonHierarchyProps = (node) =>
    node?.childNodes?.length ? { variation: 'navigation', bold: true, paddingLeft: 0 } : { variation: 'secondary' };

export const renderSidebar = (tree, node, actions) => {
    const selectNode = (e, id) => {
        e.stopPropagation();
        actions.selectNode(id);
    };

    const toggleNodeVisibility = (e, id) => {
        e.stopPropagation();
        actions.setNodeProps(id, (editedNode) => {
            // eslint-disable-next-line no-param-reassign
            editedNode.meta.visible = !editedNode.meta.visible;

            return editedNode;
        });
    };

    const canToggleNodeVisibility = {}.hasOwnProperty.call(node?.meta || {}, 'visible');

    const displayName = node?.meta?.displayName || node?.displayName || node?.type;
    const disabled = node?.meta?.disabled;
    const shouldShowToolTip = node?.meta?.showToolTip;
    const toolTipMessage = node?.meta?.toolTipMessage;

    return Object.keys(tree).length ? (
        <ConditionalWrap
            condition={node?.childNodes?.length && !node?.root}
            wrap={(children) => (
                <>
                    <NodeContainer className={`NodeContainer__${node.id}`}>{children}</NodeContainer>
                    <Spacer $spacing={SPACING} />
                </>
            )}
        >
            {!node.root && (
                <div>
                    <Tooltip
                        element={
                            <NodeButton
                                label={displayName}
                                variation="secondary"
                                onClick={(e) => selectNode(e, node.id)}
                                disabled={disabled}
                                onMouseEnter={() => actions.hoverNode(node.id)}
                                onMouseLeave={() => actions.unhoverAllNodes()}
                                qaId={displayName}
                                iconAfter={
                                    canToggleNodeVisibility && (
                                        <ShowHideButton
                                            handleToggle={(e) => toggleNodeVisibility(e, node.id)}
                                            visible={node.meta.visible}
                                        />
                                    )
                                }
                                {...buttonHierarchyProps(node)}
                            />
                        }
                        label={toolTipMessage}
                        enabled={shouldShowToolTip}
                    />
                    <Spacer $spacing={SPACING} />
                </div>
            )}
            {node?.childNodes?.map((childNodeKey) => renderSidebar(tree, tree[childNodeKey], actions))}
        </ConditionalWrap>
    ) : null;
};
